import { defineMessages } from 'react-intl';

export default defineMessages({
  orderRestriction: {
    description: 'Description of order restriction',
    defaultMessage: 'Restrict this user to only see orders assigned to them',
    id: 'SFGNF+',
  },
  shipmentRestriction: {
    description: 'Description of shipment restriction',
    defaultMessage: 'Restrict this user to only see shipments assigned to them',
    id: '1Zdodh',
  },
  inventoryRestriction: {
    description: 'Description of inventory restriction',
    defaultMessage: 'Restrict this user to only see Inventory data',
    id: 'eBNhXS',
  },
  workstationApprovalRestriction: {
    description: 'Description of workstation approval restriction',
    defaultMessage: 'Require workstation approval for this user',
    id: 'Jt/M24',
  },
  learnMoreHere: {
    description: 'Learn more here link label',
    defaultMessage: '(Learn more here)',
    id: 'uFgD2m',
  },
  workstationApprovalHeader: {
    description: 'Learn more about workstation approval title',
    defaultMessage: 'What is Workstation Approval?',
    id: '7Y2qV4',
  },
  workstationApprovalContent1: {
    description: 'First blurb about workstation approval',
    defaultMessage:
      "Workstation Approval is a security feature that allows you to restrict access to ShipStation to one or more physical workstations for a particular user. A common use of this feature would be to restrict a user's ability to access ShipStation from any location outside of your corporate environment.",
    id: 'J1m/Sr',
  },
  workstationApprovalContent2: {
    description: 'Second blurb about workstation approval',
    defaultMessage:
      'After enabling Workstation Approval for a user, they will not be able to login to ShipStation until an administrator has logged in and authorized the account. Admin approval must be performed on the same computer and same browser that the user will use to access ShipStation.',
    id: 'clVBwO',
  },
  workstationApprovalContent3: {
    description: 'Third blurb about workstation approval',
    defaultMessage:
      "Approval for a user will expire after a period of one year, but can be disapproved by viewing the user's profile in Settings > General Settings. Please note that approval is saved in a browser cookie and approval will revert to a denied status if the browser cookies are cleared.",
    id: 'xPMXuK',
  },
  closeHelp: {
    description: 'Close Help button text',
    defaultMessage: 'Close Help',
    id: 'cSgH6c',
  },
  workstationApproved: {
    description: 'Describes the current status of a user on this workstation',
    defaultMessage: 'Currently <b>Approved</b> on this workstation',
    id: 'Bw/J3j',
  },
  workstationNotApproved: {
    description: 'Describes the current status of a user on this workstation',
    defaultMessage: 'Currently <b>Unapproved</b> on this workstation',
    id: 'oqoRxG',
  },
  approveAccess: {
    description: 'Describes the current status of a user on this workstation',
    defaultMessage: 'Approve access to this workstation',
    id: '7b3pyI',
  },
  unapproveAccess: {
    description: 'Describes the current status of a user on this workstation',
    defaultMessage: 'Disapprove access to this workstation',
    id: 'GA1QUT',
  },
  cannotEditSelf: {
    description: 'tool tip text indicating a user cannot edit their own restrictions',
    defaultMessage: 'You cannot edit restrictions for your own user account',
    id: 'AftEWt',
  },
  errorAuthorizing: {
    description: 'error message indicating authorizing workstation approval failed.',
    defaultMessage: 'Error approving workstation access. Please try again.',
    id: 'cPSKuD',
  },
});
